<template>
<!--콘텐츠 영역-->
    <div class="mainbusiness_wrap">
        <div id="sub_contents" class="mainbusiness planbusiness">
            <div class="tit">
                    <div>SONGWON FOUNDATION</div>
                    <h3>
                        송원문화재단은 참신함과 차별성 그리고 영향력 있는 사업을 진행하여
                        인재를 양성하고 우수한 사회인으로 성장할 수 있도록 보탬이 되고자 합니다.
                    </h3>
                    <p>
                        초중고생, 대학 재학생 장학금뿐만 아니라 유엔평화 장학사업과 같이 수혜 대상을 확대해
                        보다 많은 학생들이 혜택을 받을 수 있도록 지속적으로 노력하고 있습니다.
                    </p>
                </div>
                <div class="cont_wrap" style="height:1050px;">
                    <div class="cont">
                        <div><img :src="require('./../../assets/img/sub/01/planning3.png')" /></div>
                        <div>
                            <h3>송원빌딩 입주업체 연계 학습비 지원사업</h3>
                            <span>부산 서부 대상 B2C업체 협업 장학사업 협약</span>
                            <p>
                                송원빌딩이 위치한 ‘부산 서부지역’을 대상으로 B2C(businesstoconsumer) 업체와 협업할 수 있는 장학사업을 구상하였습니다.<br/>
                                신용회복위원회, 주택금융공사와 협업하여저소득층 학습비를 지원하며<br/>
                                단순 학습비용 지원을 넘어 진로상담과 다양한 교육 기회를 되고자 합니다.
                            </p>
                            <a href="/notice/detail?id=64ae6ab1dfe7c83faae0e727&type=1">자세히 보기 +</a>
                        </div>
                    </div>
                    <div class="cont">
                        <div><img :src="require('./../../assets/img/sub/01/planning4.png')" /></div>
                        <div>
                            <h3>송원빌딩 입주업체 연계 학습비 지원사업</h3>
                            <span>부산 서부 대상 B2C업체 협업 장학사업 협약</span>
                            <a href="/notice/detail?id=64ae6ab1dfe7c83faae0e727&type=1" >자세히 보기  +</a>
                        </div>
                    </div>
                    <div class="cont">
                        <div><img :src="require('./../../assets/img/sub/01/planning5.png')" /></div>
                        <div>
                            <h3>그룹홈 교육비 지원</h3>
                            <span>장학생 8명 선발, 학원비 지원</span>
                            <p>
                                부산 남구지역 소규모 그룹홈 학생의 학원 학습비를 지원합니다.
                                이를 통해 그룹홈 학생이 학원비 걱정없이 학업에 집중하며 성장할 수 있도록
                                사업을 추진하고 있습니다.
                            </p>
                            <a href="/notice/detail?id=64ae695ddfe7c83faae0e716&type=1">자세히 보기 +</a>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</template>

<script>

export default {
    data: () => ({
        message: "Brochure.vue"
    }),
    methods: {},
    computed: {
        IS_MOBILE() {
            return this.$root.$data.isMobileMode;
        }
    },
    destroyed() { },
    created() {
        console.log("created - " + this.message);
    }
};
</script>

<style></style>
 


// WEBPACK FOOTER //
// src/components/sub01/PlanningBusiness.vue